import { sendAdalyserEvent } from './client';

const ADALYSER_SIGN_UP_EVENT = 'lce2';

export const adalyserSignUp = (): void => {
  sendAdalyserEvent(ADALYSER_SIGN_UP_EVENT);
};
